import { IFormGroupConfiguration } from '@/components/atoms/form/entities/form-group-configuration.interface';
import { FormFieldType } from '@/components/atoms/form/form-field/form-field-type.definition';
import { TranslationKey } from '../../../../../modules';

export class FormConfigurationProvider {

    static get emailConfig(): IFormGroupConfiguration<string> {
        return {
            label: { key: TranslationKey.Common_email_recipient },
            name: FormFieldType.Email,
            type: FormFieldType.Email,
            validators: []
        };
    }

}
